// 养老待遇资格认证——微信，主流程
const wxMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `authentication/wx/index${i + 1}`,
  name: `authenticationWxIndex${i + 1}`,
  component: () => import(`@/views/society/authentication/wx/index${i + 1}.vue`)
}))

// 养老待遇资格认证——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `authentication/zfb/index${i + 1}`,
  name: `authenticationZfbIndex${i + 1}`,
  component: () => import(`@/views/society/authentication/zfb/index${i + 1}.vue`)
}))
// 养老待遇资格认证——皖事通，主流程
const wstMainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `authentication/wst/index${i + 1}`,
  name: `authenticationWstIndex${i + 1}`,
  component: () => import(`@/views/society/authentication/wst/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 养老待遇资格认证——微信，开始
    ...wxMainRoutes,

    // 养老待遇资格认证——支付宝，主流程
    ...zfbMainRoutes,
    // 养老待遇资格认证——皖事通，主流程
    ...wstMainRoutes
  ]
}
